import AuthUtil from '@/utils/auth.util'
import { Auth0Plugin, getInstance as getAuth0PluginInstance } from "@/auth";

const AuthModule = {
  namespaced: true,
  state: {
    user: {
      id: null,
      firmId: null,
      firstName: '',
      lastName: '',
      email: '',
      mobile: '',
      is_admin: 0,
      permissions: []
    },
    // master_user: {
    //   id: null,
    //   firmId: null,
    //   firstName: '',
    //   lastName: '',
    //   email: '',
    //   mobile: '',
    //   is_admin: 0,
    //   permissions: []
    // },
    // master_token: AuthUtil.getMaterAuthToken() || undefined,
    token: AuthUtil.getAuthToken() || undefined,
  },
  mutations: {
    SET_USER (state, userObj) {
      state.user = userObj
    },
    SET_MASTER_USER (state, userObj) {
      state.master_user = userObj
    },
    SET_FIRM (state, firm) {
      state.user.firm = firm
    },
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_MASTER_TOKEN (state, token) {
      state.master_token = token
    },
    CLEAR_TOKEN (state) {
      state.token = undefined
      // state.master_token = undefined
    }
  },
  actions: {
    setUser ({ commit }, userObj) {
      commit('SET_USER', userObj)
    },
    setMasterUser ({ commit }, userObj) {
      commit('SET_MASTER_USER', userObj)
    },
    setToken ({ commit }, token) {
      commit('SET_TOKEN', token)
      AuthUtil.setAuthToken(token)
    },
    setMasterToken ({ commit }, token) {
      commit('SET_MASTER_TOKEN', token)
      AuthUtil.setAuthMasterToken(token)
    },
    async clearToken ({ commit }) {
      commit('CLEAR_TOKEN')
      AuthUtil.removeAuthToken()
      // Logout user from auth0
      const Auth0Plugin = getAuth0PluginInstance();
      const ready = await new Promise(resolve => {
        // We need the Auth0Client on the plugin to be ready before
        // we can call its logout method without causing an error.
        if (!Auth0Plugin.loading) {
          resolve(true);
        }
        else {
          const unwatch = Auth0Plugin.$watch("loading", (loading) => {
            if (loading === false) {
              unwatch();
              resolve(true);
            }
          });
        }
      });
      Auth0Plugin.logout({ returnTo: `${window.location.origin}/login` })
    }
  },
  getters: {
    fullName (state) {
      return state.user.firstName.trim()
    },
    hasRole: state => role => {
      const roles = state.user.roles || []
      return roles.findIndex(r => r.name === role) > -1
    },
    hasPermission: state => permission => {
      const permissions = state.user.permissions || []
      return permissions.findIndex(p => p.name === permission) > -1
    },
    masterHasPermission: state => permission => {
      const permissions = state.master_user.permissions || []
      return permissions.findIndex(p => p.name === permission) > -1
    },
    hasFirmPermission: state => permission => {
      const permissions = state.user.firm ? state.user.firm.permissions : []
      return permissions.findIndex(p => p.name === permission) > -1
    },
    hasGivenContractPermission: state => permission => {
      const givenContracts = state.user.firm && state.user.firm.givenContracts ? state.user.firm.givenContracts : []
      return !!givenContracts.find(c => (c.permissions || []).findIndex(p => p.name === permission) > -1)
    },
    hasContractPermission: state => permission => {
      const contracts = state.user.firm && state.user.firm.contracts ? state.user.firm.contracts : []
      return !!contracts.find(c => (c.permissions || []).findIndex(p => p.name === permission) > -1)
    },
    startRoute(state) {
      const attributes = state.user.attributes || [];

      const attribute = attributes.find(
        attribute => attribute.code === "start_route"
      );

      return attribute ? attribute.value : "profile";
    },
    orderSplitPreference(state) {
      const attributes = state.user.attributes || [];

      const attribute = attributes.find(
        attribute => attribute.code === "order_split_preference"
      );

      return attribute ? attribute.value : "50,50";
    },
    dictionary(state) {
      const attributes = state.user.attributes || [];

      const attribute = attributes.find(
        attribute => attribute.code === "dictionary"
      );

      return attribute ? attribute.value : "stormport";
    }
  }
}

export default AuthModule



// WEBPACK FOOTER //
// ./src/store/modules/auth.module.js